import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { OrderState, StateWithOrder } from '../order-state';
import { getOrderState } from './feature.selector';

const getOrderInvoicePaymentState: MemoizedSelector<
  StateWithOrder,
  StateUtils.EntityLoaderState<void>
> = createSelector(getOrderState, (state: OrderState) => state.orderInvoicePayment);

export const getOrderInvoicePaymentLoading = (orderId: string): MemoizedSelector<StateWithOrder, boolean> =>
  createSelector(getOrderInvoicePaymentState, (state: StateUtils.EntityLoaderState<void>) =>
    StateUtils.entityLoadingSelector(state, orderId),
  );
